import { useGetFundsAccess } from '../../../../shared/hooks';

export const useFunds = () => {
  const { error, loading } = useGetFundsAccess();

  return { hasAccessToFundsApp: loading ? false : error?.code !== 401 };
};
